import { render, staticRenderFns } from "./home_service.vue?vue&type=template&id=87d8ce2a&scoped=true&"
import script from "./home_service.vue?vue&type=script&lang=js&"
export * from "./home_service.vue?vue&type=script&lang=js&"
import style0 from "./home_service.vue?vue&type=style&index=0&id=87d8ce2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d8ce2a",
  null
  
)

export default component.exports